module.exports = __webpack_public_path__ + "static/media/SP_S_Jacquard_Vela_DK Grey_LT Grey.783959de.png";